module.exports = __webpack_public_path__ + "static/media/banner5.6d52b1b7.jpg";